import PropTypes from "prop-types";
// @mui material components
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 3 PRO React base styles
import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;
  const currentYear = new Date().getFullYear();


	function cynefianwebsite(e){
		window.open("http://www.stellarrcm.com","_blank");
	  }


  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
           Copyright &copy;
                  <Link
  style={{ color: "white", textDecoration: "none", marginRight: "0.25rem" }}
  onClick={(e) => cynefianwebsite(e)}
>
  StellarRCM
</Link>
{currentYear}

            <MDBox fontSize={size.md} color={light ? "white" : "dark"} mb={-0.5} mx={0.25}>
              
            </MDBox>
           
          </MDBox>
          <MDBox
            component="ul"
            sx={({ breakpoints }) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              listStyle: "none",
              mt: 3,
              mb: 0,
              p: 0,

              [breakpoints.up("lg")]: {
                mt: 0,
              },
            })}
          >
           
            <MDBox component="li" px={2} lineHeight={1}>
            <Link to="/termsandconditions" style={{ textDecoration: "none", color: light ? "white" : "dark" }}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  Terms & Conditions
                </MDTypography>
              </Link>
            </MDBox>
           
            <MDBox component="li" pl={2} lineHeight={1}>
            <Link to="/privacypolicy" style={{ textDecoration: "none", color: light ? "white" : "dark" }}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  Privacy
                </MDTypography>
              </Link>
            </MDBox>

            <MDBox component="li" pl={2} lineHeight={1}>
            <Link to="blank" style={{ textDecoration: "none", color: light ? "white" : "dark" }}>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  Help
                </MDTypography>
              </Link>
            </MDBox>

          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
